'use strict';

var React = require('react');

var SvgWalletIcon = function SvgWalletIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 5.75v8.5a2.25 2.25 0 0 0 2.25 2.25h8.5a2.25 2.25 0 0 0 2.25-2.25v-1c.304-.228.5-.591.5-1v-2c0-.409-.196-.772-.5-1v-.75a2.25 2.25 0 0 0-2.25-2.25h-.75v-.5a2.25 2.25 0 0 0-2.25-2.25h-5.5a2.25 2.25 0 0 0-2.25 2.25Zm2.25-.75a.75.75 0 0 0-.75.75v.5h7v-.5a.75.75 0 0 0-.75-.75h-5.5Zm9.75 5.5h-3.75v1.5h3.75v-1.5Zm-.5-1.5v-.5a.75.75 0 0 0-.75-.75h-9.25v6.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-.75h-3.5c-.69 0-1.25-.56-1.25-1.25v-2c0-.69.56-1.25 1.25-1.25h3.5Z"
  }));
};
SvgWalletIcon.displayName = "WalletIcon";

exports.SvgWalletIcon = SvgWalletIcon;
